module.exports = __webpack_public_path__ + "static/71-69ccb0a319f8e76033d7255433aa01c4.png";